import { render, staticRenderFns } from "./WineProductPage.vue?vue&type=template&id=dc32263e&scoped=true"
import script from "./WineProductPage.vue?vue&type=script&lang=js"
export * from "./WineProductPage.vue?vue&type=script&lang=js"
import style0 from "./WineProductPage.vue?vue&type=style&index=0&id=dc32263e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc32263e",
  null
  
)

export default component.exports